// A site created via "Criar Keepo PLUS" (the free-Keepos-limit modal) marks itself
// with this flag so the first draft save can bypass the free-limit check server-side
// (see SaveDraftForm.php's `intendedSubscription`) and the publish flow knows to skip
// the "não quero PLUS" opt-out - the modal click is already the user's consent to
// subscribe. Cleared once the draft is discarded; harmless if left behind otherwise,
// since a fresh uuid is used for every new draft.
const plusRequiredCreationKey = (siteId: string) => `${siteId}:plus-required-creation`;

export const isPlusRequiredCreation = (siteId: string): boolean => {
  try {
    return !!localStorage.getItem(plusRequiredCreationKey(siteId));
  } catch (e) {
    return false;
  }
};

export const markPlusRequiredCreation = (siteId: string): void => {
  localStorage.setItem(plusRequiredCreationKey(siteId), "true");
};

export const clearPlusRequiredCreation = (siteId: string): void => {
  localStorage.removeItem(plusRequiredCreationKey(siteId));
};
